import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { IHeaderNotificationState } from './state';

export const GET_VISIBLE = 'getVisible';
export const GET_TYPE = 'getType';
export const GET_TEXT = 'getText';
export const GET_CLOSEDELAY = 'getCloseDelay';
export const GET_CLOSEAFTERDELAY = 'getCloseAfterDelay';
export const GET_DISMISSIBLE = 'getDismissible';

export const getters: GetterTree<IHeaderNotificationState, IRootState> = {
    [GET_VISIBLE]: state => state.visible,
    [GET_TYPE]: state => state.type,
    [GET_TEXT]: state => state.text,
    [GET_CLOSEAFTERDELAY]: state => state.closeAfterDelay,
    [GET_CLOSEDELAY]: state => state.closeDelay,
    [GET_DISMISSIBLE]: state => state.isDismissible
};
